module.exports = __webpack_public_path__ + "static/media/chess-pawn.9175efe9.svg";